module.exports = __webpack_public_path__ + "8b42c952b8e5e282a7bf70ef524118be.svg";